import styled from 'styled-components';
import { Card as ConstellationCard, Spacer } from '@zillow/constellation';

export const Card = styled(ConstellationCard)`
  display: flex;
  flex-direction: row;
  height: 100px;
`;

export const PhotoContainer = styled.div`
  align-items: left;
`;

export const Details = styled(Spacer)`
  display: flex;
  flex-direction: column;
`;
